import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';

export const state = {
  reserveParams: {},
}

const store = createStore({
  plugins: [createPersistedState({
    paths: ["reserveParams"]
  })],
  mutations: {
    saveParam(state, value) {
      state.reserveParams = value;
    },
    clearParam(state) {
      state.reserveParams = '';
    }
  }
});

export default store